import React from "react";

import TextAttributeForm from "../../../components/AttributeForm/TextAttributeForm";
import {useFeedbackTools} from "../../../components/FeedbackTools";
import AvatarWithUpload from "../../../components/AvatarWithUpload";
import {useHome} from "./HomeContext";
import {useHomeAction} from "./HomeActionContext";
import ScoreWarning from "../ScoreWarning";
import {nameValidationSchema} from "./homeValidationSchema";

import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import ButtonBase from "@mui/material/ButtonBase";
import EditIcon from '@mui/icons-material/Edit';
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";


const HomeHeader = () => {
    const {name, apartments, icon, infoScore, updateIcon, url} = useHome();
    const {formName, handleSubmit} = useHomeAction();
    const {showSuccessNotification} = useFeedbackTools();

    const clipBoardEnabled = !!navigator.clipboard;
    const initialLetter = name ? name.charAt(0) : "C";
    const apartmentLine = apartments.length === 1 ? "1 appartamento" : `${apartments.length} appartamenti`
    const scoreColor = infoScore.missingAttribute.length > 0 ? "warning.main" : "success.main"

    const handleCopyLink = () =>{
        if (clipBoardEnabled) {
            navigator.clipboard.writeText(url)
            showSuccessNotification("Link copiato negli appunti")
        }
    }

    return <Card sx={{mt: {md: 3}}}>
        <Box sx={{p: 2}}>
            <Stack spacing={2}>
                <Stack direction="row" gap="24px">

                    <AvatarWithUpload imgSrc={icon} imgAlt={name} width="120px" height="120px" onUpdate={updateIcon}>
                        {initialLetter}
                    </AvatarWithUpload>

                    <Stack direction='column'  flexGrow={1} spacing={2}>
                        <Stack direction='column'>
                            <ButtonBase onClick={formName.open}>
                                <Stack direction="row" justifyContent="space-between" alignItems="center"
                                       flexGrow={1}>
                                    <Typography variant="h4" textAlign="left">{name}</Typography>
                                    <EditIcon fontSize="small"/>
                                </Stack>

                            </ButtonBase>

                            <Typography variant="subtitle1">{apartmentLine}</Typography>
                        </Stack>
                        <Typography variant="subtitle2" color={scoreColor}>
                            {`Punteggio: ${infoScore.score}`}
                        </Typography>
                    </Stack>

                </Stack>
                {
                    infoScore.missingAttribute.length > 0 && <ScoreWarning attributes={infoScore.missingAttribute}/>
                }
                {
                    formName.show && <TextAttributeForm attribute="name"
                                                        label="Nome"
                                                        value={name}
                                                        validationSchema={nameValidationSchema}
                                                        onClose={formName.close}
                                                        onSubmit={(data) => handleSubmit(formName, data)}
                                                        isLoading={formName.loading}/>
                }
                <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
                    <Link href={url} noWrap variant="body2" color="text.primary" underline="none" target="_blank" rel="noopener">
                        Visualizza sito web dedicato
                    </Link>
                    {
                        clipBoardEnabled &&
                        <IconButton onClick={handleCopyLink} sx={{p:0}}>
                            <ContentCopyIcon fontSize="small"/>
                        </IconButton>
                    }
                </Stack>
            </Stack>

        </Box>
    </Card>
}

export default HomeHeader;